import React from 'react'

const CarouselItem = ({ item = {}, link } = {}) => (
  <a
    title={item.title}
    href={link}
    className="group/item mr-3.5 block min-h-[99px] w-[117px] first:ml-8 last:mr-8"
  >
    <div
      className={`h-[79px] w-[117px] overflow-hidden rounded-xl bg-[length:127px_89px] bg-center transition-all duration-500 group-hover/item:bg-[length:117px_79px]`}
      style={{
        backgroundImage: `url('${item.img}')`
      }}
    />

    <div className="line-clamp-2 w-[111px] pt-1 text-xs font-normal text-gray-1100">
      {item.title}
    </div>
  </a>
)

export default CarouselItem
